import * as React from 'react';
import { Route } from 'react-router-dom';
import TransitStopsList from './ui/TransitStopsList';
import StopEdit from '../Stops/StopEdit';
import TransitStop from './ui/TransitStop';
import TransitStopInfo from './ui/TransitStopInfo';
import BreadcrumbedComponent from '@components/BreadcrumbedComponent/BreadcrumbedComponent';

export const useTransitStopsRoutes = () => {
    return (
        <Route
            path="stops"
            element={<BreadcrumbedComponent />}
            handle={{ crumb: (data: any) => ({ name: 'Stops', ...data }) }}
        >
            <Route index element={<TransitStopsList />} />
            <Route path="new" element={<StopEdit />} />
            <Route
                path=":stopId"
                element={<TransitStop />}
                loader={({ params }) => params}
                handle={{ crumb: ({ stopId }) => ({ id: stopId }) }}
            >
                <Route index element={<TransitStopInfo />} />
                <Route path="edit" element={<StopEdit />} />
            </Route>
        </Route>
    );
};
